export function socialToLinks(vcfCard, socialLinksForVCard) {
  const links = Object.keys(socialLinksForVCard).reduce((prev, key, idx) => {
    prev += `item${idx + 1}.URL:${socialLinksForVCard[key]}\r\n`;
    prev += `item${idx + 1}.X-ABLABEL:${
      key[0].toUpperCase() + key.slice(1)
    }\r\n`;
    return prev;
  }, "");

  return vcfCard
    .getFormattedString()
    .replace(/SOCIALPROFILE;CHARSET=UTF-8;/gm, "SOCIALPROFILE;")
    .replace(/REV:/gm, links + "REV:");
}
